import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({
  apiKey: '08e8cb042bd69741ebfe57b78b69c969',
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.REACT_APP_ENV || process.env.NODE_ENV,
  enabledReleaseStages: ['staging', 'production'],
  appVersion: process.env.REACT_APP_VERSION,
});

export const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);
